// hooks/useFilterReset.js
import { useCallback } from "react";

export const useFilterReset = ({
  setSearchValue,
  setDebouncedSearchValue,
  setSelectedStatus,
  setSelectedDistrictId,
  setSelectedSubCategoryId,
  setSelectedCategory,
  setPerPage, // ✅ NEW
  setCurrentPage,
  fetchFunction,
  setSelectedSportId,
  setOrgSelectedCategory,
  setSelectedInsitutionCategory,
  setSelectedGender,
  setSelectedKitSize,
  setSelectedShoeSize,
  setSelectedLevelOfAchievement,
}) => {
  return useCallback(() => {
    setSearchValue("");
    setDebouncedSearchValue && setDebouncedSearchValue("");
    if (setSelectedStatus) setSelectedStatus(0);
    setSelectedDistrictId?.("");
    setSelectedSubCategoryId?.("");
    setSelectedCategory?.("");
    setOrgSelectedCategory?.("");
    setPerPage(10); // ✅ reset perPage to 10
    setCurrentPage(1);
    setSelectedSportId("");
    setSelectedInsitutionCategory?.("");
    setSelectedGender?.(0);
    setSelectedKitSize?.("");
    setSelectedShoeSize?.("");
    setSelectedLevelOfAchievement?.("");
     // ✅ clean values before sending to API
    const clean = (value) => (value === undefined || value === null ? "" : value);

    fetchFunction(
      10, // perPage
      1,  // page
      0,  // status
      clean(""), // search
      clean(""), // city
      clean(""), // sub_category_type
      clean(""), // sport_id
      clean(""),
      clean(""),
       // org_id
    );
    // fetchFunction(10, 1, 0, "", "", "");
  }, [
    setSearchValue,
    setDebouncedSearchValue,
    setSelectedStatus,
    setSelectedDistrictId,
    setSelectedSubCategoryId,
    setSelectedCategory,
    setOrgSelectedCategory,
    setPerPage, // ✅ dependency
    setCurrentPage,
    fetchFunction,
    setSelectedSportId,
    setSelectedInsitutionCategory,
    setSelectedGender,
    setSelectedKitSize,
    setSelectedShoeSize,
    setSelectedLevelOfAchievement
  ]);
};


